import React from 'react';
import './FlexibleArrow.scss';

const FlexibleArrow = () => <div className="flexible-arrow" />;

export default FlexibleArrow;
